import React from 'react';
import { 
  SpinnerContainer, 
  Spinner, 
  LoadingText, 
  VerifiedSpinner,
  InlineVerifiedSpinner,
  PulseLoader,
  SkeletonContainer,
  SkeletonBar
} from './styles';
import { ReactComponent as VerifiedIcon } from '../../assets/verified.svg';

const LoadingSpinner = ({
    size = 50,
    thickness = 4,
    speed = 0.8,
    showText = true,
    text = 'Loading...',
    textColor = '#333',
    textSize = 16,
    textWeight = '500',
    fullPage = false,
    variant = 'logo', // Default to logo instead of spinner
    overlay = false,
    inline = false,
    center = true,
    color,
    skeletonLines = 3
  }) => {
    
    const renderLoader = () => {
      switch (variant) {
        case 'logo':
          return (
            <VerifiedSpinner $size={size} $speed={speed}>
              <VerifiedIcon />
            </VerifiedSpinner>
          );
        
        case 'inline-logo':
          return (
            <InlineVerifiedSpinner $size={size} $speed={speed} $color={color}>
              <VerifiedIcon />
            </InlineVerifiedSpinner>
          );
        
        case 'pulse':
          return (
            <PulseLoader $size={size} $color={color} />
          );
        
        case 'skeleton':
          return (
            <SkeletonContainer>
              {Array.from({ length: skeletonLines }, (_, i) => (
                <SkeletonBar 
                  key={i} 
                  $delay={i * 0.2}
                  $width={i === skeletonLines - 1 ? '60%' : '100%'}
                />
              ))}
            </SkeletonContainer>
          );
        
        case 'spinner':
        default:
          return (
            <Spinner 
              $size={size} 
              $thickness={thickness}
              $speed={speed}
              $color={color}
            />
          );
      }
    };

    const content = (
      <SpinnerContainer 
        $fullPage={fullPage}
        $inline={inline}
        $center={center}
        $overlay={overlay}
      >
        {renderLoader()}
        {showText && variant !== 'skeleton' && (
          <LoadingText 
            $showText={showText}
            $textColor={textColor}
            $textSize={textSize}
            $textWeight={textWeight}
          >
            {text}
          </LoadingText>
        )}
      </SpinnerContainer>
    );

    return content;
  };

  // Convenience exports for common patterns
  export const LogoLoading = (props) => (
    <LoadingSpinner {...props} variant="logo" text="Loading..." />
  );

  export const PulseLoading = (props) => (
    <LoadingSpinner {...props} variant="pulse" showText={false} />
  );

  export const SkeletonLoading = (props) => (
    <LoadingSpinner {...props} variant="skeleton" showText={false} />
  );

  // Truly inline loading - just the spinner, no container
  export const InlineLoading = ({ size = 14, speed = 0.8, color }) => (
    <InlineVerifiedSpinner $size={size} $speed={speed} $color={color}>
      <VerifiedIcon />
    </InlineVerifiedSpinner>
  );

  export const OverlayLoading = (props) => (
    <LoadingSpinner {...props} overlay fullPage text="Please wait..." />
  );
  
  export default LoadingSpinner;